var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 14.6667H1.8335C1.56016 14.6667 1.3335 14.44 1.3335 14.1667C1.3335 13.8934 1.56016 13.6667 1.8335 13.6667H14.1668C14.4402 13.6667 14.6668 13.8934 14.6668 14.1667C14.6668 14.44 14.4402 14.6667 14.1668 14.6667Z",
    fill: "#075FCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7266 9.13333L8.90659 13.9533C7.95992 14.9 6.43326 14.9 5.49326 13.96L2.41992 10.8867L10.6599 2.64667L13.7333 5.72C14.6733 6.66 14.6733 8.18667 13.7266 9.13333Z",
    fill: "#075FCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.66 2.64665L2.41337 10.8867L1.80671 10.28C0.866708 9.33998 0.866708 7.81332 1.81337 6.86665L6.63337 2.04665C7.58004 1.09998 9.10671 1.09998 10.0467 2.03998L10.66 2.64665Z",
    fill: "#075FCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59322 11.7333L7.69322 12.6333C7.50655 12.82 7.20655 12.82 7.01988 12.6333C6.83322 12.4466 6.83322 12.1466 7.01988 11.96L7.91988 11.06C8.10655 10.8733 8.40655 10.8733 8.59322 11.06C8.77988 11.2466 8.77988 11.5466 8.59322 11.7333Z",
    fill: "#075FCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5134 8.81333L9.72007 10.6067C9.53341 10.7933 9.2334 10.7933 9.04674 10.6067C8.86007 10.42 8.86007 10.12 9.04674 9.93333L10.8401 8.14C11.0267 7.95333 11.3267 7.95333 11.5134 8.14C11.6934 8.32667 11.6934 8.62667 11.5134 8.81333Z",
    fill: "#075FCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.8e0f38ac5c7995c770d299ca1b11c869.svg";
export { ForwardRef as ReactComponent };